import React from 'react';

const QuoteCategoryChips = ({ categories }) => {
  if (!categories || categories.length === 0) return null;
  return (
    <div className="md:col-span-2">
      <span className="text-xs text-gray-500 block mb-1">Catégories demandées :</span>
      <div className="flex gap-1.5 flex-wrap">
        {categories.map((c) => (
          <span key={c} className="text-xs px-2 py-0.5 bg-gray-100 text-gray-700 rounded">{c}</span>
        ))}
      </div>
    </div>
  );
};

export default QuoteCategoryChips;
